import React from 'react';
import './css/DetallesModal.css';

const DetallesModal = ({ products, newAddProduct, onClose }) => {
    if (!products) return null;

    return (
        <div className="modalD">
            <div className="modalD-content">
                <span className="closeMD-button" onClick={onClose}>&times;</span>
                <h3>{products.name}</h3>
                <img src={products.img} alt={products.name} style={{ width: '100%' }} />
                <p>Precio: $ {products.price}</p>
                <p>Descripción: {products.description || "No hay descripción disponible."}</p>
                <button className="button-addCart" onClick={() => newAddProduct(products)}>
                    Añadir al carrito
                </button>
            </div>
        </div>
    );
};

export default DetallesModal;
